import {GetFormattedNumber} from "../../../../../Helpers/Formatters";
import {EsignerRole} from "../../../../../Common/Constant";
import {getESignerContactValues, isMissingPhoneOrEmail, setPhoneAndEmail, getEsignPrefillData} from "./eSignerFunctions";

const getFaInfo = (formState) => {
  const {retrieveAccount} = formState.pages;
  const { clientData: { licenseCheckResponse } } = retrieveAccount;
  const { clientData, selectedOwner } = retrieveAccount;

  if (!licenseCheckResponse)
    return null;

  let primaryAgent = retrieveAccount &&
    retrieveAccount.clientData &&
    retrieveAccount.clientData.licenseCheckResponse &&
    retrieveAccount.clientData.licenseCheckResponse.quoteFAList &&
    retrieveAccount.clientData.licenseCheckResponse.quoteFAList.length > 0 &&    
    retrieveAccount.clientData.licenseCheckResponse.quoteFAList.find(x => x.primary === true);

  if (primaryAgent === undefined)
    return null;

  let emailList = [{value: primaryAgent.email, label: primaryAgent.email}];
  let phoneList = [{value: primaryAgent.phone, label: primaryAgent && GetFormattedNumber(primaryAgent.phone)}];

  // add mobile phone values to phone list if any are present
  primaryAgent.mobilePhones && primaryAgent.mobilePhones.forEach((element, index) => {
    phoneList.push({value: element, label: GetFormattedNumber(element)})
  });

  const { phoneVal, emailVal } = setPhoneAndEmail(emailList, phoneList);
  const { prefillPhone, prefillEmail, prefillAuthentication } = getEsignPrefillData(EsignerRole.FINANCIAL_ADVISOR , formState);
 
  return {
    firstName: primaryAgent.firstName,
    lastName: primaryAgent.lastName,
    email: prefillEmail || emailVal,
    phone: prefillPhone ||  phoneVal,
    emailList: emailList,
    phoneList: phoneList,
    missingContact: false, // it doesn't matter that we are missing contact info for FA
    role: EsignerRole.FINANCIAL_ADVISOR,
    authentication: prefillAuthentication ||  '',
  }
}

export default getFaInfo;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/getFaInfo.js